<template>
  <el-form-item :label="i18nt('designer.setting.maxLength')">
    <el-input type="number" @input.native="inputNumberHandler" class="hide-spin-button" min="1" v-model="maxLength" style="width: 100%"></el-input>
  </el-form-item>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'maxLength-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    const maxLength = computed({
      get() {
        return props.optionModel['maxLength'];
      },

      set(newValue) {
        // if ((!newValue && (newValue !== 0)) || isNaN(newValue)) {
        if (newValue === undefined || newValue === null || isNaN(newValue)) {
          props.optionModel.maxLength = null;
        } else {
          props.optionModel.maxLength = Number(newValue);
        }
      },
    });

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
      maxLength,
    };
  },
};
</script>

<style scoped></style>
